import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { podeAcessar, rotaInicial, type Area } from "@foto/shared";
import { useAuth } from "./useAuth.js";
import { LoginPage } from "./LoginPage.js";
import { Girando, Vazio } from "../../components/ui.js";

/**
 * Porta de entrada de uma área.
 *
 * Antes era um booleano `exigeAdmin`, que só sabia distinguir dois papéis. Com o
 * `kiosk` no meio, quem decide é a tabela de permissões em `@foto/shared` — a
 * mesma que o backend consulta. Duas listas separadas divergem, e aí o menu
 * oferece uma tela que a API recusa.
 */
export function RequireAuth({ children, area }: { children: ReactNode; area?: Area }) {
  const { autenticado, papel, carregando } = useAuth();

  if (carregando) {
    return (
      <div className="flex min-h-full items-center justify-center">
        <Girando className="size-6 text-texto-fraco" />
      </div>
    );
  }

  if (!autenticado) return <LoginPage />;

  if (area && !podeAcessar(papel, area)) {
    // Uma conta de quiosque existe para projetar, e só. Mandá-la à galeria é
    // mais útil do que explicar o que ela não pode fazer.
    if (papel === "kiosk") return <Navigate to={rotaInicial(papel)} replace />;

    return (
      <Vazio
        titulo="Esta área é da administração"
        descricao="Sua conta é de operador. Peça a um administrador para abrir esta tela por você."
      />
    );
  }

  return <>{children}</>;
}
